import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-contact-sales-modal',
  templateUrl: './contact-sales-modal.component.html',
  styleUrls: ['./contact-sales-modal.component.scss'],
})
export class ContactSalesModalComponent {
  constructor(
    private _activeModal: NgbActiveModal,
    private _location: Location,
  ) {}

  public dismiss(): void {
    this._activeModal.dismiss();
    this._location.back();
  }
}
